<template>
  <field-block :title="title">
    <p v-if="helpText" class="mb-1">{{ helpText }}</p>
    <v-autocomplete
      v-model="conId"
      :label="label"
      placeholder="Search contacts"
      item-text="label"
      :loading="loading"
      :items="contactsOptions"
      :search-input.sync="search"
      :disabled="disabled"
    >
      <template v-slot:no-data>
        <contact-not-found
          v-if="showNotFoundBlock"
          class="pa-4"
          :showAddButton="hasPermission('add_contacts') && !hideAddButton"
          :search="search"
          @created="selectCreatedContact"
        />
        <div v-else></div>
      </template>
    </v-autocomplete>
  </field-block>
</template>

<script>
import { mapActions } from 'vuex';
import ContactNotFound from '@/views/contacts/components/ContactNotFound';

export default {
  name: 'SelectContactField',
  components: {
    ContactNotFound,
  },
  props: {
    value: String,
    helpText: String,
    title: {
      default: 'Choose Contact',
      type: String,
    },
    label: String,
    hideAddButton: Boolean,
    disabled: Boolean,
    excludeIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      contacts: [],
      searchDelay: null,
      loading: false,
      search: '',
      selectedContact: null,
    };
  },
  computed: {
    conId: {
      get() {
        return this.value;
      },
      set(conId) {
        this.$emit('input', conId);

        if (conId) {
          this.selectedContact = this.contacts.find((i) => i.con_id === conId);
        } else {
          this.selectedContact = null;
        }
      },
    },

    showNotFoundBlock() {
      return (
        !!(this.search || '').trim() && !this.loading && !this.contacts.length
      );
    },

    contactsOptions() {
      return [...this.contacts, this.selectedContact].reduce((acc, contact) => {
        if (contact?.con_id && !this.excludeIds.includes(contact.con_id)) {
          acc.push({
            label: this.getContactName(contact),
            value: contact.con_id,
          });
        }

        return acc;
      }, []);
    },
  },
  watch: {
    search() {
      this.searchContacts(this.search);
    },
    value(conId) {
      this.loadSelectedContact(conId);
    },
  },
  methods: {
    ...mapActions(['loadFilteredContacts', 'loadSingleContactShort']),

    searchContacts(search) {
      clearTimeout(this.searchDelay);

      this.searchDelay = setTimeout(() => {
        this.search = search || '';

        if (!search) {
          return;
        }

        this.loading = true;
        this.loadFilteredContacts({
          filters: {
            fields: ['first_name', 'last_name', 'name'],
            limit: 10,
            name: search,
          },
        })
          .then(({ results }) => {
            this.contacts = results || [];
          })
          .finally(() => {
            this.loading = false;
          });
      }, 200);
    },

    selectCreatedContact({ con_id }) {
      this.conId = con_id;
    },

    loadSelectedContact(conId) {
      if (!conId) {
        this.selectedContact = null;
        return;
      }

      if (this.selectedContact?.con_id === conId) {
        return;
      }

      this.loadSingleContactShort({
        filters: { id: conId },
      }).then((contact) => {
        if (contact) {
          this.selectedContact = contact;
        }
      });
    },
  },
};
</script>
